import ProfileDetailList from './ProfileDetailList';

export default ProfileDetailList;

export type {
  IProfileDetailField,
  IProfileDetailGroup,
  IProfileDetailListProps
} from './ProfileDetailList';
